import { useState } from 'react'
import type { BrokerSession } from '@/api/admin'
import { revokeBrokerSession } from '@/api/admin'

interface Props {
  session: BrokerSession
  onRevoked: () => void
}

export default function SessionRow({ session, onRevoked }: Props) {
  const [busy, setBusy] = useState(false)

  const handleRevoke = async () => {
    if (!confirm(`Revogar sessão de ${session.user_email}?`)) return
    setBusy(true)
    try {
      await revokeBrokerSession(session.session_id, 'admin_action')
      onRevoked()
    } catch (e) {
      alert(`Falha: ${e instanceof Error ? e.message : String(e)}`)
    } finally {
      setBusy(false)
    }
  }

  return (
    <tr data-testid={`session-row-${session.session_id}`}>
      <td>{session.user_email}</td>
      <td>{session.source_ip}</td>
      <td>{new Date(session.issued_at).toLocaleString()}</td>
      <td>{new Date(session.last_activity_at).toLocaleString()}</td>
      <td>{session.active ? 'Ativa' : 'Revogada'}</td>
      <td>
        {session.active && (
          <button
            onClick={handleRevoke}
            disabled={busy}
            data-testid={`revoke-${session.session_id}`}
          >
            {busy ? '...' : 'Revogar'}
          </button>
        )}
      </td>
    </tr>
  )
}
